import React, { useEffect, useState } from "react";
import PeerAILogo from "../../../assets/images/peerai_white.png";
import { PiShootingStar } from "react-icons/pi";
import "./DefaultChat.scss";



import PropTypes from "prop-types";



  
  
const defaultQuestions = [
  "Can you review the code in VoirRef.cs and recommend standard coding practises?",
  "Explain the logic in BasketDownloadAsZip API",
  "Can you suggest how to handle authorization in Mediabox Independence project so that only authorized user can navigate to different pages if I want to leverage JWT Token?",
  "How can we improve the performance of MediaBaseActions_ExportDocs_Execute method?",
];
DefaultChat.propTypes = {
  handleDefaultChat: PropTypes.any.isRequired,
  config:PropTypes.any.isRequired
};

export default function DefaultChat({ handleDefaultChat ,config}) {
  const[chatQuestions,setChatQuestions]=useState([])
 
  const sendMessage = (message) => {
    handleDefaultChat(message);
  };

  const fetchQuestions=async(projectName)=>{
      const questions=await fetch(`${process.env.REACT_APP_API_URL}/chat_routers/getQuestions/${config.projectNames[0]}`)
      const res=await questions.json()
      console.log("-----------------------------------");
      console.log(res[0].questions);
      console.log("Fetching questions");
      if(res[0].questions.length>0){
      setChatQuestions(res[0].questions)
      }
      else{
        setChatQuestions(defaultQuestions)
      }
  }

  useEffect(()=>{
    if(config.projectNames.length>0){
      fetchQuestions()
    }
    else{
      setChatQuestions(defaultQuestions)
    }
  },[config])

  return (
    <div>
       {/* <h1>Welcome, {userName}!</h1> */}
      <div className="default-questions">
        <div className="view-port">
          <img src={PeerAILogo} alt="logo" />
          <div className="questions">
            {chatQuestions.map((item, i) => {
              return (
                <div
                  key={i}
                  onClick={() => {
                    sendMessage(item);
                  }}
                  className="question"
                >
                  <PiShootingStar />
                  <p>{item}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
